import { PureLightTheme } from "../../../../styles/theme"
import { COLORS } from "../../../../styles/variables"

/** Тред под L2 в модалке: без дополнительного отступа. */
export const replyRowIndentFlat = {
    marginLeft: 0,
}

/** replyDepth === 1: ответ непосредственно под корневым комментарием. */
export const replyRowIndentDepth1 = {
    marginLeft: "44px",
    [PureLightTheme.breakpoints.down("sm")]: {
        marginLeft: "32px",
    },
}

/**
 * replyDepth >= 2: ответ на ответ и всё глубже — второй «ступень», без дальнейшего смещения.
 */
export const replyRowIndentNested = {
    marginLeft: "78px",
    [PureLightTheme.breakpoints.down("sm")]: {
        marginLeft: "60px",
    },
}

/** «Показать ещё» под корнем — выравниваем с первым столбцом ответов (depth 1). */
export const MainStack = replyRowIndentDepth1

export const AvatarStyle = {
    width: "35px",
    height: "35px",
    marginRight: "16px",
    [PureLightTheme.breakpoints.down("sm")]: {
        width: "30px",
        height: "30px",
        marginRight: "12px",
    },
}

export const StackWithComment = {
    width: "100%",
    minHeight: "65px",
}

export const TypNameLastName = {
    display: "-webkit-box",
    overflow: "hidden",
    textOverflow: "ellipsis",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 1,
    overflowWrap: "anywhere",
}

export const TypText = {
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    wordBreak: "break-word",
}

export const SpanFirstName = {
    fontWeight: 500,
    color: COLORS.CERULEAN,
}

export const TypDate = {
    marginRight: "17px",
}

export const TypAnswer = {
    cursor: "pointer",
    "&:hover": {
        textDecoration: "underline",
    },
}

export const ButtonStyle = {
    minWidth: "auto",
    padding: "0px",

    "&:hover": {
        backgroundColor: "transparent",
    },
}
